import { urlParser } from '@hh.ru/browser-api-utils';

export const printResume = () => {
    const url = urlParser(location.pathname + location.search);
    url.params.print = [true];

    window.open(url.href, '_blank', 'noopener');
};
